import Table from './table';
import TableHead from './table-head';
import TableHeadRow from './table-head-row';
import TableHeadCell from './table-head-cell';
import TableBody from './table-body';
import TableRow from './table-row';
import TableCell from './table-cell';

Table.Head = TableHead;
Table.HeadRow = TableHeadRow;
Table.HeadCell = TableHeadCell;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;

export default Table;



// WEBPACK FOOTER //
// ./src/views/Plugins/Table/index.js